import * as actionTypes from '../types/contracts';

export function getContractsByStock(payload) {
  return {
    type: actionTypes.GET_CONTRACTS_BY_STOCK,
    payload
  };
}
export function getContractsByStockSuccess(payload) {
  return {
    type: actionTypes.GET_CONTRACTS_BY_STOCK_SUCCESS,
    payload
  };
}
export function getContractsByStockFail(payload) {
  return {
    type: actionTypes.GET_CONTRACTS_BY_STOCK_FAIL,
    payload
  };
}

export function deleteContract(payload) {
  return {
    type: actionTypes.DELETE_CONTRACT,
    payload
  };
}

export function deleteContractSuccess(payload) {
  return {
    type: actionTypes.DELETE_CONTRACT_SUCCESS,
    payload
  };
}

export function deleteContractFail(payload) {
  return {
    type: actionTypes.DELETE_CONTRACT_FAIL,
    payload
  };
}

export function addContract(payload) {
  return {
    type: actionTypes.ADD_CONTRACT,
    payload
  };
}

export function addContractSuccess(payload) {
  return {
    type: actionTypes.ADD_CONTRACT_SUCCESS,
    payload
  };
}

export function addContractFail(payload) {
  return {
    type: actionTypes.ADD_CONTRACT_FAIL,
    payload
  };
}

export function updateContract(payload) {
  return {
    type: actionTypes.UPDATE_CONTRACT,
    payload
  };
}

export function updateContractSuccess(payload) {
  return {
    type: actionTypes.UPDATE_CONTRACT_SUCCESS,
    payload
  };
}

export function updateContractFail(payload) {
  return {
    type: actionTypes.UPDATE_CONTRACT_FAIL,
    payload
  };
}
